import { ComponentIds, } from "@inter-ikea-core/core";
import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { updateStabilityZoneComponentInSection } from "../functions/stability";
export class OnSnapshotLoadSystem extends SystemBase {
    constructor(core, entityManager) {
        super(ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID);
        this.core = core;
        this.entityManager = entityManager;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "OnSnapshotLoadSystem";
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
    }
    onRemoveComponent(_entity, _oldComponent) {
        super.onRemoveComponent(_entity, _oldComponent);
        this.updateStabilityZonesOnSnapshotLoad(_entity);
    }
    updateStabilityZonesOnSnapshotLoad(_entity) {
        this.core.services.sceneManager.entities
            .filter((entity) => entity.hasComponent(COMPONENT_IDS.SECTION_COMPONENT))
            .forEach((section) => {
            updateStabilityZoneComponentInSection(section);
        });
    }
}
